const state = {
  sites: {
    isLoading: false,
    many: {},
    one: null,
  },
};

export default state;
